@if (context) {
  <div class="ClaimSubmissionReview__FormGroup">
    @for (item of reviewList; track item) {
      <div
        class="ClaimSubmissionReivew"
        [ngStyle]="{ order: item.value.position }"
      >
        <ng-container body>
          @if (useThatUseClaimItemsInformation(item.key)) {
            @if (item?.value?.patientInformationContent) {
              <lib-claim-items-information-review
                [claimItemsInfoConfig]="item.value[item.key + 'Content']"
                [title]="item.value.title"
                [isEditable]="isEditable"
                [context]="getContext(item.key)"
                (editIconClickedValue)="editIconClickedValue(item.key)"
              ></lib-claim-items-information-review>
            }
          }
          @if (item.key === 'supportingDocumentation') {
            <lib-supporting-documentation-review
              [documentationConfig]="item?.value"
              [isEditable]="isEditable"
              [summaryPageDocumentUploadedFiles]="
                summaryPageDocumentUploadedFiles
              "
              [supportingDocumentationUploadedFiles]="
                supportingDocumentationUploadedFiles
              "
              [documentUploadUrl]="documentUploadUrl"
              (editIconClickedValue)="editIconClickedValue(item.key)"
            ></lib-supporting-documentation-review>
          }
          @if (item.key === 'claimLineInformation') {
            <lib-claim-line-info-review
              [claimInfoConfig]="item.value"
              [claimLineInfoContext]="getContext(item.key)"
              [isEditable]="isEditable"
              (editIconClickedValue)="editIconClickedValue(item.key)"
            ></lib-claim-line-info-review>
          }
          <!-- Editing sections -->
          @if (isEditable) {
            @if (item.key === 'totalProviderCharges') {
              <lib-total-provider-charges-review
                [totalProviderChargesConfig]="item.value"
                [totalClaimLineCharges]="totalClaimLineCharges"
              ></lib-total-provider-charges-review>
            }
            @if (
              item.key === 'certification' && item?.value.certificationForm
            ) {
              <simple-card class="ClaimSubmissionReview__SimpleCard">
                <div
                  title
                  class="ClaimSubmissionReview__Title"
                  data-test-id="ClaimSubmissionReviewTitle"
                >
                  <h6 class="t-bold">{{ item.value.title }}</h6>
                </div>
                @for (
                  config of item.value.certificationForm.controls;
                  track config
                ) {
                  <form-group
                    [form]="certificationForm"
                    [configs]="[config]"
                    direction="action"
                  ></form-group>
                }
              </simple-card>
            }
          }
        </ng-container>
      </div>
    }
  </div>
} @else {
  <preloader size="large"></preloader>
}
